/* eslint-disable import/no-default-export */
import { SET_FUELTYPES_GROUP } from '../../../actionTypes'

const initialState = {
    fuelTypesGroup: [{ fuelType: '', groupedGenerations: [] }]
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_FUELTYPES_GROUP: {
            const { content } = action.payload
            return {
                ...state,
                fuelTypesGroup: content
            }
        }
        default:
            return state
    }
}
